export const setMeta = (meta) => {
  const titleTemplate =
    "titleTemplate" in meta
      ? meta.titleTemplate || ""
      : " | Pontaパス";
  document.title = meta.title + titleTemplate;
};
